import os from 'os';
import {
  format, transports, createLogger,
} from 'winston';
import { v4 as uuid } from 'uuid';
import CATEGORIES from '../../constants/LOG_CATEGORIES';

const networkInterfaces = os.networkInterfaces();

const loggerConfig = {
  level: 'info',
  format: format.combine(format.json()),
  defaultMeta: {
    tenant: 'candidate-onboarding',
    environment: process.env.APPLICATION_ENV,
    'datacenter-name': process.env.AWS_REGION || 'us-east-1',
    'application-name': process.env.APPLICATION_NAME || 'candidate-checkout-app',
    'application-version': process.env.RELEASE_TAG || 'development',
    'host-ip': networkInterfaces?.eth0?.[0]?.address || '0.0.0.0',
  },
  transports: [new transports.Console({ level: process.env.LOG_LEVEL })],
};

const winstonLogger = createLogger(loggerConfig);

const Logger = (categoryName: string) => ({

  info(data?: any): void {
    const isObj = typeof data === 'object';
    const isString = typeof data === 'string';

    const sendData = isObj ? data : {};
    winstonLogger.info({
      'created-at': new Date().toISOString(),
      'transaction-id': sendData?.transactionId || uuid(),
      label: categoryName,
      message: data && isString ? data : `info - ${categoryName}`,
      ...sendData,
    });
  },

  error(data?: any): void {
    const isObj = typeof data === 'object';
    const isString = typeof data === 'string';

    const sendData = isObj ? data : {};
    winstonLogger.error({
      'created-at': new Date().toISOString(),
      'transaction-id': sendData?.transactionId || uuid(),
      label: categoryName,
      message: data && isString ? data : `error - ${categoryName}`,
      ...sendData,
    });
  },

  warn(data?: any): void {
    const isObj = typeof data === 'object';
    const isString = typeof data === 'string';

    const sendData = isObj ? data : {};
    winstonLogger.warn({
      'created-at': new Date().toISOString(),
      'transaction-id': sendData?.transactionId || uuid(),
      label: categoryName,
      message: data && isString ? data : `warn - ${categoryName}`,
      ...sendData,
    });
  },

  debug(data?: any): void {
    const isObj = typeof data === 'object';
    const isString = typeof data === 'string';

    const sendData = isObj ? data : {};
    winstonLogger.debug({
      'created-at': new Date().toISOString(),
      'transaction-id': sendData?.transactionId || uuid(),
      label: categoryName,
      message: data && isString ? data : `debug - ${categoryName}`,
      ...sendData,
    });
  },

});

const accessLogger = Logger(CATEGORIES.ACCESS);
const backendLogger = Logger(CATEGORIES.BACKEND);
const requestLogger = Logger(CATEGORIES.REQUEST);

export {
  accessLogger,
  backendLogger,
  requestLogger,
};
